import * as React from "react"

const SmallCaption = ({text}) => (
  <div className="small--caption ma uppercase max-200 size-medium text-center text-normal">{text}</div>
) 
export default SmallCaption
